import { PlayResult } from '../../../../interfaces';
import { VodPlaybackOption } from '../../titles/types/playback-option';
import { PlayData } from '../api';
import { getMediaId } from './get-media';
import { handlePlayResult } from './handle-play-result';
import { client } from './huawei-client';

export async function playHuaweiTrailer(option: VodPlaybackOption): Promise<PlayData> {
  const mediaId = getMediaId(option, 'clip');

  const data = await client.post<PlayResult>('/EPG/JSON/Play', {
    contentid: option.platformTitleId,
    playtype: 5, // trailer type
    mediaid: mediaId,
  });

  const result = handlePlayResult(data);

  return {
    status: true,
    platform: 'huawei',
    url: result.url,
    message: '',
    licenseUrl: '',
    token: '',
    sessionId: '',
    releasePid: '',
    account: '',
    mediaId: mediaId,
  };
}
